/**
 *
 * Asynchronously loads the component for StatementsPublicPage
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
